import { useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';

export const useBuddySessionId = () => {
  const [sessionId, setSessionId] = useState<string>(uuidv4());

  const generateNewSession = useCallback(() => {
    const newSessionId = uuidv4();
    setSessionId(newSessionId);
    return newSessionId;
  }, []);

  return {
    sessionId,
    generateNewSession,
  };
};
